<template>
  <div>
    <div class="columns is-vcentered">
      <div class="column info-block mb-5 is-one-third-tablet has-text-centered">
        <h2 class="is-uppercase has-text-weight-bold mb-2">Йога вне границ и времени!</h2>
        <p class="mb-2">
          Занимайтесь с нами в любом месте, в удобное время.
        </p>
        <p class="has-text-justified">
          В рамках ежемесячной подписки вас ждет увлекательное погружение в активную йогу - динамика и статика,
          медитации и стойки на руках. Уже более 350 уроков доступны для занятий прямо сейчас от НУЛЯ и для
          продолжающих.
        </p>
        <a href="/yoga-online" class="button is-medium is-primary mt-4">Узнать подробнее</a>
        <a href="/videos" class="button is-medium is-text mt-4"
           v-if="this.isLoggedInUser">Перейти к занятиям</a>
      </div>
      <div class="column">
        <div class="tile is-ancestor is-desktop mb-5">
          <VideoCard v-for='(video, i) in videos' :key="i" class="video" v-bind:video="video">
          </VideoCard>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import VideoCard from "../components/VideoCard";

export default {
  name: 'YogaOnlineContent',
  data: function () {
    return {
      videos: window.vueData.videos,
      isLoggedInUser: !!window.vueData.user,
    }
  },
  methods: {
    getUser: function () {
      return this.isLoggedInUser;
    }
  },
  created() {
    this.getUser();
  },
  components: {
    VideoCard
  }
}
</script>

<style>
.info-block {
  width: 50%;
}


@media screen and (max-width: 1013px) {
  .info-block {
    width: 100%;
  }

  .desk-only {
    display: none;
  }
}
</style>
